import { useEffect } from "react";
import styles from "./requestDetails.module.css";
import { useState } from "react";

import { ArrowUp } from "react-feather";
import moment from "moment";
import RequestResolution from "./RequestResolution";
import RequestSummary from "./RequestSummary";

const RequestDetails = ({
  maintenanceDetails,
  updateMaintenanceDetails,
  setLoading,
}) => {
  const [openPanel, setOpenPanel] = useState(null);

  const togglePanel = (panel) => {
    setOpenPanel((prev) => (prev === panel ? null : panel));
  };

  useEffect(() => {
    if (maintenanceDetails) {
      if (maintenanceDetails?.resolution) {
        setOpenPanel("resolution");
      } else {
        setOpenPanel("summary");
      }
    }
  }, [maintenanceDetails]);

  return (
    <>
      <div className={`${styles.UserMainDiv}`}>
        <div className={`${styles.DetailTopSec}`}>
          <div className={`${styles.DetailTopImgSec}`}>
            <img src={maintenanceDetails?.image} class={`${styles.IMG}`} />
          </div>
          <div className={`${styles.DetailTopConSec}`}>
            <p className={`${styles.Title}`}>{maintenanceDetails?.title}</p>
            <div className={`${styles.MainReCardIdStatus}`}>
              <p className={`${styles.MainReID}`}>
                {maintenanceDetails?.tenant_name}{" "}
                <span>{maintenanceDetails?.apt_name}</span>
              </p>
              {/* <span className={`${styles.MainReStatus} ${styles.Open}`}>
                Open
              </span> */}
              {maintenanceDetails?.is_archived === 1 && (
                <span className={`${styles.MainReStatus} ${styles.Archive}`}>
                  Archived
                </span>
              )}

              {maintenanceDetails?.is_archived !== 1 && (
                <>
                  {maintenanceDetails?.current_status === 0 && (
                    <span className={`${styles.MainReStatus} ${styles.Open}`}>
                      Open
                    </span>
                  )}
                  {maintenanceDetails?.current_status === 1 && (
                    <span
                      className={`${styles.MainReStatus} ${styles.InProgress}`}
                    >
                      In-Progress
                    </span>
                  )}
                  {maintenanceDetails?.current_status === 2 && (
                    <span className={`${styles.MainReStatus} ${styles.Closed}`}>
                      Resolved
                    </span>
                  )}
                  {maintenanceDetails?.current_status === 3 && (
                    <span
                      className={`${styles.MainReStatus} ${styles.Cancelled}`}
                    >
                      Cancelled
                    </span>
                  )}
                </>
              )}
            </div>
            <div className={`${styles.MainReCardIdStatusTwo}`}>
              <p className={`${styles.MainReDate}`}>
                Submitted {moment(maintenanceDetails?.created_at).fromNow()}
              </p>
              {maintenanceDetails?.priority === 1 && (
                <p className={`${styles.ReffStatus} ${styles.Low}`}>
                  <ArrowUp />
                  <span>Low</span>
                </p>
              )}

              {maintenanceDetails?.priority === 2 && (
                <p className={`${styles.ReffStatus} ${styles.Medium}`}>
                  <ArrowUp />
                  <span>Medium</span>
                </p>
              )}

              {maintenanceDetails?.priority === 3 && (
                <p className={`${styles.ReffStatus} ${styles.High}`}>
                  <ArrowUp />
                  <span>High</span>
                </p>
              )}
            </div>
          </div>
        </div>
        <div className={styles.AccordionSecMain}>
          {(maintenanceDetails?.resolution ||
            openPanel === "resolution" ||
            maintenanceDetails?.resolve_images?.length > 0) && (
            <RequestResolution
              isPanelOpen={openPanel === "resolution"}
              onToggle={() => togglePanel("resolution")}
              maintenanceDetails={maintenanceDetails}
              updateMaintenanceDetails={updateMaintenanceDetails}
              setLoading={setLoading}
            />
          )}

          <RequestSummary
            isPanelOpen={openPanel === "summary"}
            onToggle={() => togglePanel("summary")}
            maintenanceDetails={maintenanceDetails}
            togglePanel={togglePanel}
          />
        </div>
      </div>
    </>
  );
};

export default RequestDetails;
